import { request } from "@/utils/request";
/**
 * 查询
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/admin/role/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增
 * @param {*} data 
 * @returns 
 */
export function addApi(data) {
  return request({
    url: `/admin/role/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改
 * @param {*} data 
 * @returns 
 */
export function updateApi(data) {
  return request({
    url: `/admin/role/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data 
 * @returns 
 */
export function deleteApi(data) {
  return request({
    url: `/admin/role/delete`,
    method: "POST",
    data,
  });
}
